import { DonationType } from "@nkr/enums/donation-type";
import { ConversionType } from "@nkr/enums/conversion-type";

export interface IMicrositeConvertDonationType {
    centerId: number,
    donorId: number,
    recipientId: number,
    donorRegistrationId: number,
    micrositeRecipientId: number,
    donationType: DonationType,
    conversionType: ConversionType,
    donationDate: string
}